import {
  SET_SETTINGS
} from '../actions/types';

import {settings} from '../config'
if(!settings.durView) settings.durView = 'blocks';

let initialState =  {settings};

export default function(state: Object = initialState, action) {
  switch(action.type) {
    case SET_SETTINGS:
      window.setStorage("settings", JSON.stringify(action.payload));
      return {...state,settings:action.payload};
    default:
      return state;
  }
}
